import { PlatformLocation } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MatSidenav } from '@angular/material/sidenav';
import { PlatformService } from './services/platform/platform.service';
import { Subject } from 'rxjs';
import { MyDataService } from './services/data/data.service';
import { LoginService } from './services/auth/login/login.service';
import { UserService } from './services/user/user.service';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private destroyed$ = new Subject<void>();

  header: boolean = false;
  buttonHeader: boolean = false;
  ubicacion: string = '';
  contrato: any;
  user: any = null;

  @ViewChild(MatSidenav) sidenav: MatSidenav;

  constructor(
    private router: Router,
    private platformLocation: PlatformLocation,
    private platformSvc: PlatformService,
    private dataSvc: MyDataService,
    private loginSvc: LoginService,
    private userSvc: UserService,
    private viewportMeta: Meta
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.handleNavigation();
      }
    });
  }

  ngOnInit(): void {
    let host;
    if (environment.production) {
      host = this.platformLocation.hostname;
    } else {
      host = environment.hostDev;
    }
    console.log('HOST:', host);
    this.getPlatform(host);
    this.handleNavigation();
    this.getUser();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  handleNavigation() {
    this.ubicacion = this.router.url;

    const excludedPaths = [
      '/login',
      '/change-pass'
    ];

    const noButtonPaths = [
      '/register',
      '/activate-client',
      '/acceso-sin-registro',
      '/acceso-invitado',
      '/aviso-legal',
      '/politica-privacidad',
      '/terminos-condiciones-app',
      '/caso-web',
      '/terminos-condiciones-web',
      '/politica-cookies',
      '/caso-verify'
    ];

    if (!excludedPaths.some(path => this.ubicacion.includes(path))) {
      this.header = true;
      if (!noButtonPaths.some(path => this.ubicacion.includes(path))) {
        this.buttonHeader = true;
        if (this.ubicacion.includes('/seguimiento') && !this.user) {
          this.buttonHeader = false;
        }
      } else {
        this.buttonHeader = false;
      }
    } else {
      this.header = false;
      this.buttonHeader = false;
    }
  }

  getPlatform(url: string) {
    this.platformSvc
      .getPlatform(url)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response: any) => {
          this.contrato = response;
          this.dataSvc.setFkEntityPlatform(response.contrato_fk_entity);
          this.changeColors(this.contrato);
          this.platformSvc
            .getLogo(response.contrato_logoContrato, response.contrato_id)
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
              next: (response: any) => {
                console.log(response);
                this.dataSvc.setLogo(response.logo);
              },
              error: (e) => {
                console.log(e);
              },
            });

            if (response.contrato_logoContrato2) {
              this.platformSvc
                .getLogo(response.contrato_logoContrato2, response.contrato_id)
                .pipe(takeUntil(this.destroyed$))
                .subscribe({
                  next: (response: any) => {
                    console.log(response);
                    this.dataSvc.setLogo2(response.logo);
                  },
                  error: (e) => {
                    console.log(e);
                  },
                });
            }

            if (response.contrato_logoContrato3) {
              this.platformSvc
                .getLogo(response.contrato_logoContrato3, response.contrato_id)
                .pipe(takeUntil(this.destroyed$))
                .subscribe({
                  next: (response: any) => {
                    console.log(response);
                    this.dataSvc.setLogo3(response.logo);
                  },
                  error: (e) => {
                    console.log(e);
                  },
                });
            }
        },
        error: (e) => {
          console.log(e);
        },
      });
  }

  getUser() {
    this.userSvc
      .getPerfil()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (data) => {
          console.log(data);
          this.user = data;
          this.dataSvc.setUserPlatform(data);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  changeColors(contrato: any) {
    const root = document.documentElement;

    root.style.setProperty('--primary-color', contrato.primary_color_platform);
    root.style.setProperty(
      '--secondary-color',
      contrato.secondary_color_platform
    );
    root.style.setProperty('--gray-color', contrato.gray_color_platform);
    root.style.setProperty(
      '--secondary-text',
      contrato.secondary_text_platform
    );
  }

  navigateTo(ruta: string) {
    this.sidenav.toggle();
    this.router.navigate([ruta]);
  }

  logout() {
    this.loginSvc.logout();
    this.router.navigate(['/login']);
  }
}
